"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Palette_1 = require("./Models/Palette/Palette");
const ModularScale_1 = require("./Models/ModularScale/ModularScale");
const Typography_1 = require("./Models/Typography/Typography");
const MediaQuery_1 = require("./Models/MediaQuery/MediaQuery");
const Animation_1 = require("./Models/Animation/Animation");
class PupsConfig {
    /**
     * Inizializza una nuova configurazione.
     * Se la variabile data è settata, verranno importati i dati
     *
     * @param {Types.PupsConfig.File} [data]
     * @memberof PupsConfig
     */
    constructor(data) {
        data && this.import(data);
    }
    /**
     * Ritora la Palette colori
     *
     * @returns {Palette}
     * @memberof PupsConfig
     */
    getPalette() {
        return this.palette;
    }
    /**
     * Ritora il Modular Scale
     *
     * @returns {ModularScale}
     * @memberof PupsConfig
     */
    getModularScale() {
        return this.modularScale;
    }
    /**
     * Ritora Typography
     *
     * @returns {Typography}
     * @memberof PupsConfig
     */
    getTypography() {
        return this.typography;
    }
    /**
     * Ritora MediaQuery
     *
     * @returns {MediaQuery}
     * @memberof PupsConfig
     */
    getMediaQuery() {
        return this.mediaQuery;
    }
    /**
     * Ritora Animation
     *
     * @returns {Animation}
     * @memberof PupsConfig
     */
    getAnimation() {
        return this.animation;
    }
    //#region Import / Export
    /**
     * Importa una configurazione
     *
     * @param {Types.PupsConfig.File} data
     * @memberof PupsConfig
     */
    import(data) {
        this.palette = new Palette_1.default(data.palette);
        this.modularScale = data.modularScale ? new ModularScale_1.default(data.modularScale.base, data.modularScale.unit, data.modularScale.ratio, data.modularScale.rootBase) : new ModularScale_1.default();
        this.typography = data.typography ? new Typography_1.default(this.modularScale, data.typography.fontSize, data.typography.lineHeight, data.typography.lineWidth) : new Typography_1.default(this.modularScale);
        this.mediaQuery = new MediaQuery_1.default(data.mediaQuery);
        this.animation = data.animation ? new Animation_1.default(data.animation.timings, data.animation.easings) : new Animation_1.default();
        this.version = data.version;
    }
    /**
     * Importa la configurazione da una stringa json
     */
    importFromString(json) {
        this.import(JSON.parse(json));
    }
    /**
     * Esporta la configurazione
     *
     * @returns {Types.PupsConfig.File}
     * @memberof PupsConfig
     */
    export() {
        return {
            palette: this.palette.export(),
            modularScale: this.modularScale.export(),
            typography: this.typography.export(),
            mediaQuery: this.mediaQuery.export(),
            animation: this.animation.export(),
            version: this.version
        };
    }
    /**
     * Esporta la configurazione in una stringa json
     *
     * @returns {string}
     * @memberof PupsConfig
     */
    toJSON() {
        return JSON.stringify(this.export());
    }
}
exports.default = PupsConfig;
//# sourceMappingURL=PupsConfig.js.map